import {Accordion, AccordionDetails, AccordionSummary, Divider, Typography, makeStyles} from '@material-ui/core';
import {KeyboardArrowDown, KeyboardArrowRight} from '@material-ui/icons';
import React, {useState} from 'react';

type FormAccordionWrapperProps = {
  title: string | JSX.Element;
  children?: React.ReactNode;
  withSeparator?: boolean;
  collapsible?: boolean;
  expanded?: boolean;
};

const useFormAccordionWrapperStyles = makeStyles(() => ({
  title: {
    fontSize: '1rem',
    lineHeight: '1.2rem',
    color: '#333333',
    marginLeft: '1.5rem',
    fontWeight: 600,
  },
  accordion: {
    boxShadow: 'none',
    '&::before': {
      display: 'none',
    },
  },
  formSeparator: (props: any) => ({
    width: '100%',
    padding: props?.collapsible ? '0.5rem 0' : '1.5rem 0',
  }),
}));

const renderTitle = (title: string | JSX.Element, className?: string) =>
  React.isValidElement(title) ? <>{title}</> : <Typography className={className}>{title}</Typography>;

export const FormWrapper = (props: FormAccordionWrapperProps) => {
  const {title, children, withSeparator, collapsible, expanded} = props;
  const [isExpanded, setIsExpanded] = useState(() => expanded ?? false);

  const classes = useFormAccordionWrapperStyles({collapsible});

  return (
    <>
      {withSeparator && (
        <div className={classes.formSeparator}>
          <Divider />
        </div>
      )}
      {collapsible ? (
        <Accordion
          className={classes.accordion}
          expanded={isExpanded}
          onChange={() => setIsExpanded(prev => !prev)}
          TransitionProps={{unmountOnExit: true}}
        >
          <AccordionSummary>
            {isExpanded ? (
              <KeyboardArrowDown aria-label={`Collapse Section ${typeof title === 'string' ? title : ''}`} />
            ) : (
              <KeyboardArrowRight aria-label={`Expand Section ${typeof title === 'string' ? title : ''}`} />
            )}
            {renderTitle(title, classes.title)}
          </AccordionSummary>
          {isExpanded && <AccordionDetails>{children}</AccordionDetails>}
        </Accordion>
      ) : (
        <div>
          {renderTitle(title, classes.title)}
          <div>{children}</div>
        </div>
      )}
    </>
  );
};
